<template>
  <div class="menus" @click="beginSelect">
    <Header class="menus-top"></Header>

    <div style="width: 100%; height: 100%">
      <div class="menus-content">
        <div class="index-content">
          <div
            class="content-item"
            v-for="(item, index) in menusListShow"
            @mouseover="clickItemsFocus(item)"
            @mouseout="clickItemsBlur(item)"
            :key="index"
          >
            <div class="content-item-topLine">
              <img
                src="@assets/img/menus/item-line-icon.png"
                alt
                class="content-item-topLine-icon"
              />
            </div>
            <div class="content-item-bottomLine">
              <img
                src="@assets/img/menus/item-line-icon.png"
                alt
                class="content-item-bottomLine-icon"
              />
            </div>

            <div class="titleName">
              <div class="titleName_div">
                <!-- <div class="titleName_icon">
                  <img
                    v-if="item.hover"
                    class="titleName_img_icon"
                    :src="imgIconList[item.iconName + 'Hover']"
                    alt=""
                  />
                  <img
                    v-else
                    class="titleName_img_icon"
                    :src="imgIconList[item.iconName]"
                    alt=""
                  />
                </div> -->
                <div style="margin-top: 10px">{{ item.name }}</div>
                
              </div>
              <img
                src="@assets/img/menus/item-triangle.png"
                class="titleName-leftIcon"
              />
              <img
                src="@assets/img/menus/item-triangle.png"
                class="titleName-rightIcon"
              />
            </div>

            <template v-if="item.type === 2">
              <div class="item-tab_list">
                <div
                  v-for="(itemtabs, indextabs) in item.list"
                  :key="indextabs"
                >
                  <template v-if="itemtabs.type == 2">
                    <div
                      class="item-tab item-tab-animation"
                      @mouseover="clickItemsFocus(itemtabs)"
                      @mouseout="clickItemsBlur(itemtabs)"
                      @click.stop="clickItemsOpen(itemtabs)"
                    >
                      {{ itemtabs.titleName }}

                      <img
                        v-if="itemtabs.isOpen || itemtabs.hover"
                        class="item-tab-name_icon"
                        :class="itemtabs.isOpen ? 'item-tab-name_icon_180' : ''"
                        src="@assets/img/menus/nlue-arr.png"
                        alt=""
                      />

                      <img
                        v-else
                        class="item-tab-name_icon"
                        src="@assets/img/menus/white-arr.png"
                        alt=""
                      />

                      <div class="item-tab-bg"></div>
                      <div class="item-tab-img1 item-tab-img-width" />
                      <div class="item-tab-img2 item-tab-img-width" />
                      <div class="item-tab-img3 item-tab-img-width" />
                      <div class="item-tab-img4 item-tab-img-width" />
                    </div>

                    <template v-if="itemtabs.isOpen">
                      <div
                        class="item-tab-list"
                        v-for="(itemC, indexC) in itemtabs.items"
                        :key="indexC"
                        @click.stop="clickItems(itemC)"
                      >
                        {{ itemC.name }}

                        <div class="item-tab-bg"></div>
                        <div
                          class="item-tab-img1 item-tab-img-width item-tab-img-width-0"
                        />
                        <div
                          class="item-tab-img2 item-tab-img-width item-tab-img-width-0"
                        />
                        <div
                          class="item-tab-img3 item-tab-img-width item-tab-img-width-0"
                        />
                        <div
                          class="item-tab-img4 item-tab-img-width item-tab-img-width-0"
                        />
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div
                      class="item-tab item-tab-animation"
                      style="margin-top: 15px"
                      @click.stop="clickItems(itemtabs)"
                    >
                      {{ itemtabs.name }}

                      <div class="item-tab-bg"></div>
                      <div
                        class="item-tab-img1 item-tab-img-width item-tab-img-width-0"
                      />
                      <div
                        class="item-tab-img2 item-tab-img-width item-tab-img-width-0"
                      />
                      <div
                        class="item-tab-img3 item-tab-img-width item-tab-img-width-0"
                      />
                      <div
                        class="item-tab-img4 item-tab-img-width item-tab-img-width-0"
                      />
                    </div>
                  </template>
                </div>
              </div>
            </template>

            <template v-else>
              <div
                class="item-tab item-tab-animation"
                v-for="(itemtabs, indextabs) in item.list"
                :key="indextabs"
                @click.stop="clickItems(itemtabs)"
                style="font-weight: 400"
              >
                {{ itemtabs.name }}
                <div class="item-tab-bg"></div>
                <div class="item-tab-img1 item-tab-img-width" />
                <div class="item-tab-img2 item-tab-img-width" />
                <div class="item-tab-img3 item-tab-img-width" />
                <div class="item-tab-img4 item-tab-img-width" />
              </div>
            </template>

            <!-- src="@assets/img/menus/edge-white2.png" -->

            <img
              src="@assets/img/menus/edge-white.png"
              alt
              class="content-item-img1 content-item-img-width"
            />
            <img
              src="@assets/img/menus/edge-white.png"
              alt
              class="content-item-img2 content-item-img-width"
            />
            <img
              src="@assets/img/menus/edge-white.png"
              alt
              class="content-item-img3 content-item-img-width"
            />
            <img
              src="@assets/img/menus/edge-white.png"
              alt
              class="content-item-img4 content-item-img-width"
            />

            <div class="content-item-bg"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="circle circle-5">
      <div
        class="circle-5-childbox"
        :class="firstStep ? 'circle5Animation' : ''"
      >
        <img
          :src="require('@assets/img/menus/circle5.png')"
          draggable="false"
        />
      </div>
    </div>
    <div class="circle circle-4">
      <img :src="require('@assets/img/menus/circle4.png')" draggable="false" />
    </div>
    <div class="circle circle-3">
      <img :src="require('@assets/img/menus/circle3.png')" draggable="false" />
    </div>
    <div class="circle circle-2">
      <img :src="require('@assets/img/menus/circle2.png')" draggable="false" />
    </div>
    <div class="earth">
      <div
        class="earth-box"
        v-show="firstStep"
        :class="firstStep ? 'eartchAnimation' : ''"
      >
        <div class="earth-border">
          <div
            class="earth-border-box"
            :class="secondStep ? 'eartchBorderAnimation' : ''"
          >
            <div class="company-name-line">
              <div class="company-name">中国房地产大数据应用服务商</div>
            </div>
            <div class="company-name-line2">
              <div class="company-name2">CRIC</div>
            </div>
            <img
              class="earth-border-img"
              :src="require('@assets/img/menus/template-four-bottom.png')"
              draggable="false"
            />
            <img
              class="earth-border-img"
              :src="require('@assets/img/menus/template-eight-around.png')"
              draggable="false"
            />
            <img
              class="earth-border-img templateCircle1"
              :src="require('@assets/img/menus/template-circle-1.png')"
              draggable="false"
            />
            <img
              class="earth-border-img"
              :src="require('@assets/img/menus/template-circle-2.png')"
              draggable="false"
            />
            <img
              class="earth-border-img templateCircle3"
              :src="require('@assets/img/menus/template-circle-3.png')"
              draggable="false"
            />
            <img
              class="earth-border-img templateCircle4"
              :src="require('@assets/img/menus/template-circle-4.png')"
              draggable="false"
            />
          </div>
        </div>
        <earthItem :firstStep="firstStep" />
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from "lodash";
import { menusList, imgIconList } from "./schema";
import earthItem from "./earth";

export default {
  mounted() {
    this.init();
  },
  data() {
    return {
      menusList,
      menusListShow: [],
      imgIconList,
      activeList: "",
      activeIndex: -1,
      activeHoverIndex: -1,
      scaleValue: 0,
      firstStep: false,
      secondStep: false,
      timer1: null,
      timer2: null,
      timer3: null,
    };
  },
  components: {
    earthItem,
    Header: () => import("@/components/header.vue"),
  },
  methods: {
    beginSelect() {
      // 用户可以点击页面关闭所有的动画
      this.stopTimer();
      this.firstStep = true;
      this.secondStep = true;
      if (this.activeIndex === -1) {
        // this.setActiveList(menusList[0], 0);
        this.menusListShow = this.menusList;
      }
    },
    init() {
      // 1. 显示地球,做放大缩小的功能
      // 1.1 最外边的刻度
      this.stopTimer();
      this.timer1 = setTimeout(() => {
        this.firstStep = true;
      }, 300);

      // 2. 隐藏地球边上的圈圈(暂时2.5s后)
      this.timer2 = setTimeout(() => {
        this.secondStep = true;
        this.timer3 = setTimeout(() => {
          // this.setActiveList(menusList[0], 0);
          this.menusListShow = this.menusList;
        }, 1100);
      }, 3500);
    },
    stopTimer() {
      this.timer1 && clearTimeout(this.timer1);
      this.timer2 && clearTimeout(this.timer2);
      this.timer3 && clearTimeout(this.timer3);
    },
    setActiveList(item, index) {
      this.activeList = item;
      this.activeIndex = index;
      this.scaleValue = 1;
    },
    hoverActiveList(index) {
      this.activeHoverIndex = index;
    },
    selectItem(item) {
      if (item.isSelf) {
        let newpage = this.$router.resolve({
          name: item.isSelf,
        });
        window.open(newpage.href, "_blank");
        return;
      }

      if (item.url) {
        window.open(item.url);
      }
    },
    clickItems(item) {
      if(item.name == '瑞库')return
      if (item.isSelf) {
        let newpage = this.$router.resolve({
          name: item.isSelf,
        });
        window.open(newpage.href, "_blank");
        return;
      }
      if (item.url) {
        window.open(item.url);
      }
    },
    clickItemsFocus(item) {
      item.hover = true;
    },
    clickItemsBlur(item) {
      item.hover = false;
    },
    clickItemsOpen(item) {
      item.isOpen = !item.isOpen;
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes circleAnimation {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes circleSecondAnimation {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.05);
  }
}

@keyframes circleMenuAnimation {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes eartchAnimation {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes circle5Animation {
  0% {
    transform: scale(1.5);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes menusAnimation {
  0% {
    bottom: -100px;
  }
  100% {
    bottom: 0;
  }
}

@keyframes templateCircle1Animation {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(90deg);
  }
}
@keyframes templateCircle3Animation {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(45deg);
  }
}
@keyframes templateCircle4Animation {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(-360deg);
  }
}

@keyframes eartchBorderAnimation {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
    display: none;
  }
}

@keyframes companyLineAnimation {
  0% {
    width: 0;
  }
  100% {
    width: 240px;
  }
}
@keyframes companyTitleAnimation {
  0% {
    width: 0;
  }
  100% {
    width: 200px;
  }
}
@keyframes companyTitle2Animation {
  0% {
    width: 0;
  }
  100% {
    width: 100px;
  }
}

@keyframes contentHeight {
  0% {
    height: 0;
    transition: height 1s;
    opacity: 0;
  }
  100% {
    height: 100%;
    transition: height 1s;
    opacity: 1;
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    -webkit-transform: translate(0, -60px); /* Safari */
    transform: stranslate(0, -60px); /* 标准语法 */
  }
  to {
    opacity: 1;
    -webkit-transform: translate(0, 0px); /* Safari */
    transform: stranslate(0, 0px); /* 标准语法 */
  }
}

.eartchAnimation {
  animation: eartchAnimation 1s;
  animation-fill-mode: forwards;
}

.circle5Animation {
  // 从放大到缩小
  animation: circle5Animation 1s;
  animation-fill-mode: forwards;
}

.menusAnimation {
  // 从下到上
  animation: menusAnimation 1s;
  animation-fill-mode: forwards;
}

.eartchBorderAnimation {
  // 关闭由大到小
  animation: eartchBorderAnimation 1s;
  animation-fill-mode: forwards;
}

.menus {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("../../assets/img/menus/background.png");
  background-size: cover;
  background-repeat: no-repeat;
  color: #fff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;

  .menus-top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }

  .menus-list {
    width: 50%;
    position: absolute;
    // bottom: 0px;
    bottom: -200px;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    z-index: 1001;

    display: flex;
    justify-content: space-around;
    align-items: center;

    .menus-list-bg {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 130%;
      transform: translateX(-50%);
      background-image: url("../../assets/img/menus/menu-bottom-second.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 64px;
      z-index: -1;
    }

    .menus-list-bg-2 {
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 140%;
      transform: translateX(-50%);
      background-image: url("../../assets/img/menus/menu-bottom-first.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 120px;
      z-index: -2;
    }

    .menus-item {
      font-size: 20px;
      text-align: center;
      margin-bottom: 16px;

      img {
        width: 80px;
        height: 80px;
      }
    }
  }

  // .hasAnimation {
  //   animation: circleMenuAnimation 0.75s linear;
  // }

  .menus-content {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    width: 100%;
    height: 100%;

    .menus-content-item {
      width: 200px;
      height: 200px;
      line-height: 200px;
      font-size: 24px;
      border-radius: 50%;
      position: relative;
      text-align: center;
      margin: 0 12px;
      font-weight: 500;

      &:hover {
        .menus-content-item__bg {
          background-image: url("../../assets/img/menus/menus-button2.png") !important;
        }
      }

      .menus-content-item__bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        background-image: url("../../assets/img/menus/menus-button.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        animation: circleAnimation 7s linear infinite;
      }
    }
  }

  .circle {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .circle-2 {
    img {
      height: 70%;
      animation: circleAnimation 100s linear infinite;
      opacity: 0.5;
    }
  }
  .circle-3 {
    img {
      height: 124%;
      animation: circleAnimation 100s linear infinite;
      opacity: 0.5;
    }
  }
  .circle-4 {
    img {
      height: 180%;
      animation: circleAnimation 120s linear infinite;
      opacity: 0;
    }
  }

  .circle-5 {
    opacity: 0.3;
    .circle-5-childbox {
      opacity: 0;
    }
  }

  .circle-5-childbox {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      height: 85%;
      animation: circleSecondAnimation 2s linear infinite alternate;
    }
  }

  .earth {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 430px;
    height: 430px;

    .earth-box {
      width: 100%;
      height: 100%;
    }

    .earth-border {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 150%;
      height: 150%;
    }

    .company-name-line2 {
      position: absolute;
      right: 480px;
      top: 498px;
      height: 1px;
      background: #fff;

      animation: companyLineAnimation 0.3s 1 1s;
      animation-fill-mode: forwards;
    }

    .company-name2 {
      position: absolute;
      left: 0;
      top: 0;
      transform: rotate(45deg) translate(-114%, -68%);
      transform-origin: 0% 100%;
      border-bottom: 1px solid #fff;
      padding-bottom: 4px;
      width: 0;
      overflow: hidden;
      white-space: nowrap;

      animation: companyTitle2Animation 0.5s 1 1.3s;
      animation-fill-mode: forwards;
    }

    .company-name {
      position: absolute;
      right: 0;
      top: 0;
      transform: rotate(-45deg) translate(100%, -96%);
      transform-origin: 100% 0%;
      border-bottom: 1px solid #fff;
      padding-bottom: 4px;
      width: 0;
      overflow: hidden;
      white-space: nowrap;

      animation: companyTitleAnimation 1s 1 1.3s;
      animation-fill-mode: forwards;
    }

    .company-name-line {
      position: absolute;
      left: 485px;
      top: 150px;
      height: 1px;
      background: #fff;

      animation: companyLineAnimation 0.3s 1 1s;
      animation-fill-mode: forwards;
    }

    .earth-border-box {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .earth-border-img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }

  .templateCircle1 {
    animation: templateCircle1Animation 1s infinite alternate;
  }
  .templateCircle3 {
    animation: templateCircle3Animation 1.5s infinite alternate;
  }
  .templateCircle4 {
    animation: templateCircle4Animation 2s infinite alternate;
  }

  .menus-content-item-special {
    font-size: 20px;
    line-height: 24px;
    color: #fff;
    width: 600px;
    height: 160px;
    background-image: url("../../assets/img/menus/closeBorder.png");
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .index-content {
    display: flex;
    width: 90%;
    justify-content: center;
    height: 48%;
    margin-top: -60px;
    .content-item {
      width: 340px;
      height: 576px;
      margin: 0 20px;
      position: relative;
      cursor: pointer;
      animation: contentHeight 0.5s linear;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      &:hover {
        .content-item-bg {
          background: rgba(74, 34, 255, 1);
          opacity: 0.15;
        }
        .titleName {
          color: #00dcff;
        }
        .titleName_img_icon {
          // filter: drop-shadow(#00dcff 80px 0) !important;
        }
      }

      .content-item-bg {
        background: rgba(0, 0, 0, 1);
        opacity: 0.15;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
      }
      .content-item-img-width {
        width: 10px;
      }
      .content-item-img1 {
        position: absolute;
        top: 0;
        left: 0;
      }
      .content-item-img2 {
        position: absolute;
        top: 0;
        right: 0;
        transform: rotate(90deg);
      }
      .content-item-img3 {
        position: absolute;
        bottom: 0;
        left: 0;
        transform: rotate(-90deg);
      }
      .content-item-img4 {
        position: absolute;
        bottom: 0;
        right: 0;
        transform: rotate(180deg);
      }
      .titleName {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        margin-top: 30px;
        display: inline-flex;
        width: 110px;
        position: relative;
        // margin-bottom: 6%;
        height: 50px;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        .titleName_div {
          display: flex;
          flex-flow: column;
          align-items: center;
        }

        .titleName_icon {
          height: 40px;
          width: 40px;
          overflow: hidden;
        }

        .titleName_img_icon {
          width: 40px;
          height: 40px;
          margin-bottom: 10px;
          // position: relative;
          // left: -80px;
          // filter: drop-shadow(#fff 80px 0);
        }

        .titleName-leftIcon {
          position: absolute;
          left: -30px;
          width: 10px;
          top: 45px;
        }
        .titleName-rightIcon {
          position: absolute;
          right: -30px;
          width: 10px;
          top: 45px;
          transform: rotate(180deg);
        }
      }

      .item-tab_list {
        height: 448px;
        overflow: auto;
      }
      .item-tab_list::-webkit-scrollbar {
        display: none;
      }

      .item-tab-animation {
        animation: fadeInDown 0.5s 0.7s forwards;
      }
      .item-tab-list_noClick{
        cursor: not-allowed;
        color: rgba(255,255,255,0.5);
      }

      .item-tab-list {
        height: 48px;
        margin: 5px 40px;
        line-height: 48px;
        position: relative;
        opacity: 1;
        font-size: 16px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          color: rgba(0, 220, 255, 1);
          .item-tab-bg {
            background: rgba(43, 120, 255, 1);
            opacity: 0.3;
            border: 1px solid rgba(255, 255, 255, 0.1);
          }
          .item-tab-img-width {
            background: url("~@assets/img/menus/edge-blue.png") no-repeat;
          }
        }
        .item-tab-name_icon {
          width: 7px;
          height: 5px;
          margin-left: 7px;
          transition: all 0.5s;
        }
        .item-tab-name_icon_180 {
          transform: rotate(180deg);
        }

        .item-tab-bg {
          background: rgba(15, 19, 174, 1);
          opacity: 0.2;
          height: 100%;
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
        .item-tab-img-width {
          width: 8px;
          height: 8px;
          border: 0;
          margin: 0;
          padding: 0;
          // background-image: image('@assets/img/menus/edge-white2.png');
          background: url("~@assets/img/menus/edge-white2.png") no-repeat;
        }
        .item-tab-img-width-0 {
          opacity: 0.5;
        }
        .item-tab-img1 {
          position: absolute;
          top: 0;
          left: 0;
        }
        .item-tab-img2 {
          position: absolute;
          top: 0;
          right: -2px;
          transform: rotate(90deg);
        }
        .item-tab-img3 {
          position: absolute;
          bottom: -2px;
          left: 0;
          transform: rotate(-90deg);
        }
        .item-tab-img4 {
          position: absolute;
          bottom: -2px;
          right: -2px;
          transform: rotate(180deg);
        }
      }

      .item-tab {
        font-weight: 600;
        height: 48px;
        margin: 15px 40px 5px 40px;
        line-height: 48px;
        position: relative;
        opacity: 0;
        // animation: fadeInDown 0.5s 0.7s forwards;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          color: rgba(0, 220, 255, 1);
          .item-tab-bg {
            background: rgba(43, 120, 255, 1);
            opacity: 0.3;
            border: 1px solid rgba(255, 255, 255, 0.1);
          }
          .item-tab-img-width {
            background: url("~@assets/img/menus/edge-blue.png") no-repeat;
          }
        }
        .item-tab-name_icon {
          width: 7px;
          height: 5px;
          transition: all 0.5s;
          position: absolute;
          right: 20px;
        }
        .item-tab-name_icon_180 {
          transform: rotate(180deg);
        }

        .item-tab-bg {
          background: rgba(15, 19, 174, 1);
          opacity: 0.2;
          height: 100%;
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
        .item-tab-img-width {
          width: 8px;
          height: 8px;
          border: 0;
          margin: 0;
          padding: 0;
          // background-image: image('@assets/img/menus/edge-white2.png');
          background: url("~@assets/img/menus/edge-white2.png") no-repeat;
        }
        .item-tab-img1 {
          position: absolute;
          top: 0;
          left: 0;
        }
        .item-tab-img2 {
          position: absolute;
          top: 0;
          right: -2px;
          transform: rotate(90deg);
        }
        .item-tab-img3 {
          position: absolute;
          bottom: -2px;
          left: 0;
          transform: rotate(-90deg);
        }
        .item-tab-img4 {
          position: absolute;
          bottom: -2px;
          right: -2px;
          transform: rotate(180deg);
        }
      }

      .content-item-topLine {
        position: absolute;
        width: 340px;
        top: -20px;
        left: 0px;
        height: 1px;
        background: rgba(255, 255, 255, 0.2);
        .content-item-topLine-icon {
          position: absolute;
          bottom: 0;
          width: 12px;
          left: calc(50% - 6px);
        }
      }
      .content-item-bottomLine {
        position: absolute;
        width: 340px;
        bottom: -20px;
        left: 0px;
        height: 1px;
        background: rgba(255, 255, 255, 0.2);
        .content-item-bottomLine-icon {
          position: absolute;
          top: 0;
          width: 12px;
          left: calc(50% - 6px);
          transform: rotate(180deg);
        }
      }
    }
  }

  @media (min-width: 1600px) {
    // .index-content {
    //   width: 80%;
    //   transition: all 0.5s;
    //   min-height: 440px;
    // }
    // .item-tab {
    //   height: 48px !important;
    //   line-height: 48px !important;
    //   transition: all 0.5s;
    // }
    // .item-tab-bg {
    //   height: 48px !important;
    //   transition: all 0.5s;
    // }
  }
  @media (max-width: 1600px) {
    // .index-content {
    //   height: 340px;
    // }
    // .item-tab {
    //   margin: 12px 20px !important;
    //   transition: all 0.5s;
    // }
  }
}
</style>